/* Cart drawer (Oct 3, AJ). change.js returns its total before the case
   discounts run, so every change re-reads /cart.js for the real numbers. Catches every add-to-cart form, posts it in the
   background and opens the drawer. The drawer reads /cart.js and draws the
   lines, the case ladder nudge and the totals. */
(function () {
  'use strict';
  var root = document.querySelector('[data-cdw]');
  if (!root) return;
  var tpl = root.getAttribute('data-template') || '';
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (base.slice(-1) !== '/') base += '/';
  var panel = root.querySelector('.cdw-panel');
  var $ = function (s) { return root.querySelector(s); };
  var lastFocus = null;

  function money(c) { return '$' + (c / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[m]; }); }
  function img(u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n; el.hidden = !n;
    });
    document.querySelectorAll('[data-cart-open]').forEach(function (a) { a.setAttribute('aria-label', 'Cart, ' + n + ' items'); });
  }

  // Oct 4, Paul: one case full price, any 2+ cases 5% off (glass and cans
  // mix), subscriptions 10% and never stacked. 750mL and subscription lines
  // don't count toward the cases. Oct 5: 3+ cases 10% off.
  // Oct 4 evening, Paul's test: his session carried EARLY10, so every cart
  // took 10% while this box said "5% off is on". A live code now gets its own
  // message, and a cart with a subscription says what the subscription saves.
  function liveCode(cart) {
    var c = (cart.discount_codes || []).filter(function (d) { return d.applicable; })[0];
    return c ? String(c.code).toUpperCase() : '';
  }
  function subSaved(it) {
    var a = it.selling_plan_allocation;
    if (!a || !a.compare_at_price || a.compare_at_price <= a.price) return 0;
    return (a.compare_at_price - a.price) * it.quantity;
  }
  function nudge(cart) {
    var cases = 0, subs = 0, last = 0;
    cart.items.forEach(function (it) {
      if (/750/.test(it.product_title || it.title)) return;
      if (it.selling_plan_allocation) { subs += it.quantity; return; }
      cases += it.quantity; last = it.original_price;
    });
    // Oct 5, Paul: 2 cases 5% off, 3+ cases 10% off (5.01% and 10.01%, each
    // case truncated to the cent, same as the cart).
    var off = Math.floor(last * 0.0501 + 1e-9), off3 = Math.floor(last * 0.1001 + 1e-9);
    var more = 2 * (last - off) - last, more3 = 3 * (last - off3) - 2 * (last - off);
    var code = liveCode(cart), head, sub, bar = true;
    if (code) {
      bar = false;
      head = code + ' is on.';
      sub = (code === 'EARLY10' ? '10% off your first order, on every case in it. ' : 'Your code is applied. ') + 'It takes the place of the case discount. They don\u2019t stack.';
    } else if (subs && cases === 0) {
      bar = false;
      head = 'Subscribe & Save is on.';
      sub = '10% off every delivery. Free shipping in the lower 48. Skip or cancel any time.';
    } else if (cases === 0) { head = 'Free shipping in the lower 48.'; sub = '2 cases take 5% off. 3 or more take 10% off.'; }
    else if (cases === 1) {
      head = 'Add a second case for just ' + money(more) + ' more.';
      sub = subs ? 'Your subscription already saves 10%. One-time cases take 5% off at 2 and 10% off at 3.' : '5% off both cases, and 3 cases take 10% off. Mix flavors, glass and cans.';
    } else if (cases === 2) {
      head = '5% off is on. Add a third case for ' + money(more3) + ' more.';
      sub = subs ? 'A third one-time case takes all of them to 10% off. Your subscription saves 10%.' : 'A third case takes every case to 10% off. Mix flavors, glass and cans.';
    } else {
      head = '10% off is on.';
      sub = subs ? cases + ' one-time cases at 10% off. Your subscription saves 10%.' : cases + ' cases, every one 10% off. Free shipping in the lower 48.';
    }
    var w = cases >= 3 ? 100 : cases === 2 ? 66 : cases === 1 ? 33 : 0;
    return '<b>' + esc(head) + '</b><span class="cdw-sub">' + esc(sub) + '</span>' + (bar ?
      '<span class="cdw-bar"><i style="width:' + w + '%"></i></span>' +
      '<span class="cdw-marks"><em' + (cases >= 1 ? ' class="on"' : '') + '>1 case</em><em' + (cases >= 2 ? ' class="on"' : '') + '>2 &middot; 5% off</em><em' + (cases >= 3 ? ' class="on"' : '') + '>3+ &middot; 10% off</em></span>' : '');
  }

  function line(it) {
    var plan = it.selling_plan_allocation ? it.selling_plan_allocation.selling_plan.name : '';
    var opts = (it.options_with_values || []).filter(function (o) { return o.value && o.value !== 'Default Title'; }).map(function (o) { return o.value; }).join(' · ');
    var price = '<span class="cdw-p">' + money(it.final_line_price) + '</span>';
    var was = it.original_line_price + subSaved(it);
    if (was > it.final_line_price) price = '<s>' + money(was) + '</s>' + price;
    return '<li class="cdw-line" data-key="' + esc(it.key) + '">' +
      '<a class="cdw-img" href="' + esc(it.url) + '"><img src="' + esc(img(it.image, 180)) + '" alt="" width="90" height="90" loading="lazy"></a>' +
      '<div class="cdw-info"><a class="cdw-t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
      (opts ? '<span class="cdw-o">' + esc(opts) + '</span>' : '') +
      (plan ? '<span class="cdw-plan">' + esc(plan) + '</span>' : '') +
      '<div class="cdw-qty"><button type="button" data-q="-1" aria-label="One less">&minus;</button><span>' + it.quantity + '</span><button type="button" data-q="1" aria-label="One more">+</button>' +
      '<button type="button" class="cdw-rm" data-q="0">Remove</button></div></div>' +
      '<div class="cdw-price">' + price + '</div></li>';
  }

  function render(cart) {
    setCount(cart.item_count);
    $('[data-cdw-count]').textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    var empty = !cart.items.length;
    $('[data-cdw-empty]').hidden = !empty;
    $('[data-cdw-foot]').hidden = empty;
    $('[data-cdw-nudge]').hidden = empty;
    $('[data-cdw-lines]').innerHTML = cart.items.map(line).join('');
    $('[data-cdw-nudge]').innerHTML = empty ? '' : nudge(cart);
    var saved = cart.items.reduce(function (s, it) { return s + (it.original_line_price - it.final_line_price) + subSaved(it); }, 0) + (cart.cart_level_discount_applications || []).reduce(function (s, d) { return s + d.total_allocated_amount; }, 0);
    $('[data-cdw-save]').hidden = !saved;
    $('[data-cdw-savings]').textContent = '−' + money(saved);
    $('[data-cdw-total]').textContent = money(cart.total_price);
  }

  function msg(t) { var m = $('[data-cdw-msg]'); m.textContent = t || ''; m.hidden = !t; }

  function getCart() { return fetch(base + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }); }

  function open() {
    lastFocus = document.activeElement;
    root.hidden = false;
    requestAnimationFrame(function () { root.classList.add('on'); });
    document.documentElement.classList.add('cdw-lock');
    setTimeout(function () { panel.focus(); }, 50);
  }
  function close() {
    root.classList.remove('on');
    document.documentElement.classList.remove('cdw-lock');
    setTimeout(function () { root.hidden = true; }, 280);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-cdw-close]')) { e.preventDefault(); close(); return; }
    var b = e.target.closest('[data-q]');
    if (!b) return;
    var li = b.closest('.cdw-line'); var key = li.getAttribute('data-key');
    var cur = parseInt(li.querySelector('.cdw-qty span').textContent, 10) || 0;
    var d = parseInt(b.getAttribute('data-q'), 10);
    var q = d === 0 ? 0 : Math.max(0, cur + d);
    li.classList.add('busy');
    fetch(base + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) })
      // Oct 5, Paul: a remove failed with a stale cart. His checkout had moved
      // the session to the Canada market, where these variants don't exist,
      // so the line keys on screen no longer matched the cart. On any failure
      // the drawer now re-reads the cart and redraws it before saying anything.
      .then(function (r) {
        if (r.ok) return getCart();
        return r.json().catch(function () { return {}; }).then(function (j) {
          return getCart().then(function (c) {
            render(c);
            var d = String(j.description || '');
            msg(/variant|line|id/i.test(d) ? 'Your cart changed somewhere else. This is the latest.' : (d || 'That did not go through. Try again.'));
            throw 'shown';
          });
        });
      })
      .then(function (c) { msg(''); render(c); })
      .catch(function (e) { li.classList.remove('busy'); if (e !== 'shown') msg('That did not go through. Try again.'); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });

  // Header cart icon opens the drawer (everywhere but the cart page).
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-cart-open]');
    if (!a || tpl === 'cart' || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    msg(''); getCart().then(render).then(open);
  });

  // Every add-to-cart form.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || f.action.indexOf('/cart/add') === -1 || tpl === 'cart' || !window.fetch) return;
    if (f.querySelector('[name="contact[email]"]')) return; // a notify form, not an add
    e.preventDefault();
    var btn = e.submitter || f.querySelector('[type="submit"]');
    var was = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-adding'); }
    var fd = new FormData(f);
    fd.delete('return_to');
    fetch(base + 'cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        msg(res.ok ? '' : (res.j.description || res.j.message || 'That could not be added.'));
        return getCart();
      })
      .then(function (c) { render(c); open(); })
      .catch(function () { f.submit(); })
      .then(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-adding'); btn.innerHTML = was; } });
  }, false);

  // Keep the header count right on first paint.
  getCart().then(function (c) { setCount(c.item_count); }).catch(function () {});
})();
